const parametersRoutes = [
    {
        path: '/parameters',
        name: 'ParametersPage',
        component: () => import('../views/parameters/ParametersComponent.vue'),
        meta: {
            requiresAuth: true,
            roles: ['ADMIN', 'SUPERADMIN'],
            permission: 'parameters',
            module: 'risksManagement',

        },
    },
];

export default parametersRoutes;